import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//基础信息相关API

const chargeManagement = {
    major: {
        queryList: config => createAPI('/skillRecognition/sfgl/queryList', 'post', config),
        initCombo: config => createAPI('/skillRecognition/sfgl/initCombo', 'post', config),
        save: config => createAPI('/skillRecognition/sfgl/save', 'post', config),
        deleteById: config => createAPI('/skillRecognition/sfgl/del', 'post', config),
        releaseRecById: config => createAPI('/skillRecognition/sfgl/releaseRecById', 'post', config),
        querySfjlBySfglid: config => createAPI('/skillRecognition/sfgl/querySfjlBySfglid', 'post', config),
        paymentRec: config => createAPI('/skillRecognition/sfgl/paymentRec', 'post', config),
        invalid: config => createAPI('/skillRecognition/sfgl/invalid', 'post', config),
        querySfnryjxmZsglInfo: config => createAPI('/skillRecognition/sfgl/querySfnryjxmZsglInfo', 'post', config),
        querySfnryjxmGwInfo: config => createAPI('/skillRecognition/sfgl/querySfnryjxmGwInfo', 'post', config),
        querySfnrejxmkcglInfo: config => createAPI('/skillRecognition/sfgl/querySfnrejxmkcglInfo', 'post', config),
        querySfnrejxmGwkcInfo: config => createAPI('/skillRecognition/sfgl/querySfnrejxmGwkcInfo', 'post', config),
        upload: config => createAPI('/skillRecognition/sfgl/upload', 'post', config),
        batchExport: config => createAPI('/skillRecognition/sfgl/batchExport', 'post', config),
        queryHzList: config => createAPI('/skillRecognition/sfgl/queryHzList', 'post', config),
    },
};

export default chargeManagement;



// WEBPACK FOOTER //
// ./src/api/modules/chargeManagement.js